import React from 'react';
import '../Styles/Hero.css';

function HeroSection() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">WE CRAFT FANTASY</h1>
      </div>
    </section>
  );
}

export default HeroSection;